import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface BookingJobStore {
    newmessage: boolean;
    setNewMessage: (newmessage: boolean) => void;
    clearStore: () => void;
}

export const useBookingJobStore = create<BookingJobStore>()(
    persist(
        (set) => ({
            newmessage: false,
            setNewMessage: (newmessage) => set({ newmessage }),
            clearStore: () => set({ newmessage: false }),
        }),
        {
            name: 'booking-job-store',
            storage: createJSONStorage(() => AsyncStorage),
        }
    )
);
